/**
 * Mind Studios Theme - Animations
 *
 * We use GSAP for animations that can't be done in CSS (or it'd be easier with GSAP)
 *
 * For documentation
 * @see https://gsap.com/
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// All GSAP plugins need to be registered. (e.g. ScrollTrigger, MorphSVG, etc.)
gsap.registerPlugin(ScrollTrigger);

// Refresh ScrollTrigger offsets for lazy-loaded images
document.querySelectorAll("img").forEach((img) => img.addEventListener("load", () => ScrollTrigger.refresh(true)));

// [data-animate] will be added automatically to block-*.php files if they follow the basic structure
// You can use the attribute on other elements as well!
document.querySelectorAll("[data-animation='fade-in']").forEach((trigger) => {
    let elements = trigger;

    gsap.from(elements, {
        scrollTrigger: {
            trigger: trigger,
            start: "top bottom", // "element viewport" position
            end: "bottom bottom",
            once: true,
            markers: false, // Use this to debug trigger points
            fastScrollEnd: true,
            preventOverlaps: true,
        },
        duration: 1.5,
        y: 100,
        autoAlpha: 0,
    });
});

// ScrollTrigger on the Vectors
const rotationClockwise = document.querySelector(".block-text .text-hero-vector");
const rotationCounterClockwise = document.querySelectorAll(
    ".block-text .text-dark-vector, .block-siteplan .siteplan-vector, .deco-vector.hero",
);
const otherVectors = document.querySelectorAll(
    ".block-form .form-vector, .block-siteplan .siteplan-vector-small, .single-apartment-vector",
);

gsap.to(rotationClockwise, {
    scrollTrigger: {
        trigger: rotationClockwise,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
    },
    rotation: 180,
});

if (rotationCounterClockwise) {
    gsap.to(rotationCounterClockwise, {
        scrollTrigger: {
            trigger: rotationCounterClockwise,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
        },
        rotation: "180_ccw",
    });
}

if (otherVectors) {
    gsap.to(otherVectors, {
        scrollTrigger: {
            trigger: otherVectors,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
        },
        rotation: 180,
    });
}

// Complex "Sun" Animation on the Hero Text Vector, if it exists

const Sun = document.querySelector(".sun svg");

if (Sun) {
    const tl = gsap.timeline();

    tl.fromTo(
        Sun.querySelector("#part-1"),
        {
            y: 40,
            opacity: 0,
            rotate: 90,
            transformOrigin: "center center",
        },
        {
            y: 0,
            opacity: 1,
            rotate: 0,
            duration: 2,
            ease: "power1.Out",
        },
    );

    tl.addLabel("scale", "+=1");

    tl.fromTo(
        Sun.querySelector("#part-2"),
        {
            opacity: 0,
            scale: 0.58,
            transformOrigin: "center center",
        },
        {
            opacity: 1,
            scale: 1,
            duration: 1,
            delay: 1.5,
            ease: "power1.inOut",
        },
        "<scale",
    );

    tl.fromTo(
        Sun.querySelector("#part-3"),
        {
            opacity: 0,
            scale: 0.77,
            transformOrigin: "center center",
        },
        {
            opacity: 1,
            scale: 1,
            duration: 1,
        },
        ">scale",
    );
}
